/*
 * DocCheck-Login für Fachkreise
 *
 * - Sitzung: Cookie mse_fk, gesetzt von /apps/doccheck/callback (signiert vom Server).
 * - Gesperrte Seiten (html.fk-locked) und Platzhalter [data-fk-slot] werden erst
 *   freigeschaltet, wenn der Server die Sitzung bestätigt hat. Der Inhalt kommt
 *   dann über /apps/doccheck/content.
 * - Fachkreise-Links (Kopfzeile, Menüs, alter doccheck-login-Link) führen zum Login
 *   und springen danach auf die aktuelle Seite zurück. Angemeldet: Hinweis und Abmelden.
 */
(function () {
  'use strict';

  var COOKIE = 'mse_fk';
  var BASE = '/apps/doccheck';
  var root = document.documentElement;

  function getToken() {
    var m = document.cookie.match(/(?:^|;\s*)mse_fk=([^;]+)/);
    return m ? m[1] : '';
  }

  // Nur für die Anzeige, geprüft wird die Signatur auf dem Server.
  function tokenExp(t) {
    try {
      var p = t.split('.')[0].replace(/-/g, '+').replace(/_/g, '/');
      while (p.length % 4) p += '=';
      return JSON.parse(atob(p)).exp || 0;
    } catch (e) {
      return 0;
    }
  }

  function clearToken() {
    document.cookie = COOKIE + '=; Max-Age=0; Path=/; Secure; SameSite=Lax';
  }

  function loginUrl() {
    return BASE + '/login?return=' + encodeURIComponent(location.pathname + location.search);
  }

  function post(route, data) {
    return fetch(BASE + '/' + route, {
      method: 'POST',
      body: new URLSearchParams(data),
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) {
      return r.json().catch(function () { return { ok: false }; });
    });
  }

  function logout(e) {
    if (e) e.preventDefault();
    clearToken();
    location.reload();
  }

  var token = getToken();
  if (token && tokenExp(token) * 1000 <= Date.now()) {
    clearToken();
    token = '';
  }
  var loggedIn = !!token;

  function isFkLink(a) {
    var h = a.getAttribute('href') || '';
    return a.classList.contains('mse-topbar__link--fachkreise')
      || h.indexOf('doccheck-login') !== -1
      || h.indexOf(BASE + '/login') === 0;
  }

  function updateLinks() {
    document.querySelectorAll('a[href]').forEach(function (a) {
      if (!isFkLink(a)) return;

      if (!loggedIn || a.hasAttribute('data-fk-login')) {
        a.setAttribute('href', loginUrl());
        return;
      }

      // Kopfzeile: ein Link für Zustand und Abmelden, damit er nicht neben dem Kunden-"anmelden" doppelt wirkt
      if (a.classList.contains('mse-topbar__link--fachkreise')) {
        var text = a.querySelector('.mse-topbar__link-text');
        if (text) text.innerHTML = 'Fachkreise: angemeldet <span class="fk-logout-hint">· abmelden</span>';
        a.classList.add('is-fk-active');
        a.setAttribute('href', '#');
        a.setAttribute('title', 'Als Fachkreis angemeldet. Klicken zum Abmelden.');
        a.addEventListener('click', logout);
        return;
      }

      // Menülinks (Mobilmenü, Footer): werden zum Abmelden
      a.textContent = 'Fachkreise abmelden';
      a.setAttribute('href', '#');
      a.addEventListener('click', logout);
    });
  }

  function unlock() {
    var slots = document.querySelectorAll('[data-fk-slot]');
    if (!loggedIn || (!slots.length && !root.classList.contains('fk-locked'))) {
      root.classList.remove('fk-checking');
      return;
    }
    root.classList.add('fk-checking');

    post('check', { t: token })
      .then(function (j) {
        if (!j.ok) {
          clearToken();
          location.reload();
          return;
        }
        // Der Server prüft die Sitzung und lässt Shopify den Inhalt mit dem Theme rendern (HTML).
        return Promise.all(Array.prototype.map.call(slots, function (slot) {
          return fetch(BASE + '/content', {
            method: 'POST',
            body: new URLSearchParams({ t: token, type: slot.dataset.fkType, handle: slot.dataset.fkHandle }),
            credentials: 'same-origin'
          })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (html) {
              if (!html.trim()) return;
              slot.innerHTML = html;
              slot.classList.add('is-loaded');
              slot.dispatchEvent(new CustomEvent('fk:loaded', { bubbles: true }));
            });
        })).then(function () {
          root.classList.remove('fk-locked');
        });
      })
      .catch(function () {})
      .then(function () {
        root.classList.remove('fk-checking');
      });
  }

  updateLinks();
  unlock();
})();
